import {getImpersonationUserToken, setImpersonationFromQueryToSession} from '@shared-utils/auth/impersonation/helpers'
import {IMPERSONATION_QUERY_KEY} from '@shared/constants/auth'

async function clearRouteOfImpersonationId(to, router) {
  if (to.query?.[IMPERSONATION_QUERY_KEY] != null) {
    const query = {...to.query}
    delete query[IMPERSONATION_QUERY_KEY]

    await router.replace({...to, query})
  }
}

export async function runImpersonationMiddleware(to, authStore, router) {
  const impersonationFromQuery = to.query?.[IMPERSONATION_QUERY_KEY]

  if (getImpersonationUserToken()) {
    return true
  }

  if (impersonationFromQuery != null) {
    setImpersonationFromQueryToSession(to.query)

    await clearRouteOfImpersonationId(to, router)

    return true
  }

  return false
}
